import { ComponentPropsWithoutRef, ElementRef, forwardRef } from 'react'

import { DialogContent as AdminDialogContent, type DialogSize } from '@iws/admin-ui/dialog'

import { cn } from '@/lib/utils'

export { Dialog, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@iws/admin-ui/dialog'

/** POS widths grow with the screen between a floor and a cap, so a till monitor gets roomier dialogs. */
const fluid: Record<DialogSize, string> = {
  sm: 'sm:max-w-[clamp(420px,34vw,520px)]',
  md: 'sm:max-w-[clamp(620px,50vw,760px)]',
  lg: 'sm:max-w-[clamp(800px,64vw,980px)]',
  xl: 'sm:max-w-[clamp(1000px,80vw,1280px)]',
  full: 'sm:max-w-[calc(100vw-64px)]',
}

/** The admin dialog with the POS radius (8px) and fluid widths. */
export const DialogContent = forwardRef<
  ElementRef<typeof AdminDialogContent>,
  ComponentPropsWithoutRef<typeof AdminDialogContent>
>(({ className, size = 'md', ...props }, ref) => (
  <AdminDialogContent ref={ref} size={size} className={cn('grid-cols-[minmax(0,1fr)] rounded-md', fluid[size], className)} {...props} />
))
DialogContent.displayName = 'DialogContent'
